import React, { useState, useEffect } from "react";
import "./cookies.css";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookie-consent", "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner">
      <p>
        This site uses minimal cookies to remember your game session.  
        By continuing, you accept this.
      </p>
      <button onClick={acceptCookies}>Okay</button>
    </div>
  );
};

export default CookieConsent;
